import CustomInput from "../../atoms/customInput/CustomInput";
import SpecificButton from "../../atoms/specificButton/SpecificButton";
import { LanguageContext } from "../../utils/context/languageContext";
import { LanguageKeys } from "../../utils/languageKeys";
import { handleErrorMessage, isValidEmail } from "../../utils/utils";
import { ArrowRight } from "lucide-react";
import React, { useContext } from "react";
import { useConfig } from "../../utils/context/configContext";

interface EmailStepProps {
	onComplete: (value: any) => void;
	initialValue?: any;
	onStepComplete?: (value: any) => Promise<void> | void;
}

const EmailStep = ({ onComplete, initialValue, onStepComplete }: EmailStepProps) => {
	const [value, setValue] = React.useState(initialValue || "");
	const [message, setMessage] = React.useState<string | undefined>(undefined);
	const [loading, setLoading] = React.useState(false);
	const { translate } = useContext(LanguageContext) || {};
	const config = useConfig();
	const handleNext = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setLoading(true);
		try {
			if (!value.trim()) {
				setMessage(translate?.(LanguageKeys.emailRequired));
				return;
			} else if (!isValidEmail(value.trim())) {
				setMessage(translate?.(LanguageKeys.validEmail));
			} else {
				await onStepComplete?.(value);
				onComplete?.(value);
			}
		} catch (error) {
			setMessage(handleErrorMessage(error));
		} finally {
			setLoading(false);
		}
	};
	return (
		<div className="w-full max-w-md">
			<form className="mt-[3.5rem]" onSubmit={handleNext}>
				<div>
					<CustomInput
						required
						type="text"
						id="name"
						data-testid="onboarding-email-input"
						placeholder={translate?.(LanguageKeys.enterEmail)}
						value={value}
						onChange={(e) => {
							setMessage(undefined);
							setValue(e.target.value);
						}}
					/>
					{message && (
						<p
							style={{
								color: config?.style?.input?.inputErrorColor || "#000",
								fontSize: config?.style?.input?.inputErrorFontSize || "16px",
							}}
						>
							{message}
						</p>
					)}
				</div>
				<div className="flex justify-end mt-[.5rem]">
					<SpecificButton type="submit" data-testid="onboarding-next-btn" disabled={!value.trim() || loading} buttonText={translate?.(LanguageKeys.next)} postfixIcon={<ArrowRight size={14} />} />
				</div>
			</form>
		</div>
	);
};

export default EmailStep;
